import { useSelector } from 'react-redux';

import { SpartacuxSellerAdsManagementState } from '@/sellerAdsManagement/SellerAdsManagementState';

export const partnerAdThemeSelector = (
  state: SpartacuxSellerAdsManagementState,
) => state.sellerAdsManagement?.partnerAdTheme || undefined;

export const usePartnerAdTheme = () => useSelector(partnerAdThemeSelector);
